import { formatDateTime } from '@formosa/shared/utils/formatDateTime';
import {
  formatFundAmount,
  formatSignedFundAmount,
  getAmountTone,
  tf,
} from '../../constants/fundConstants';
import {
  resolvePositionAmount,
  resolvePositionDirectionLabel,
  resolvePositionPairLabel,
  resolvePositionStatusLabel,
  resolvePositionTime,
} from '../../constants/positionConstants';

export default function WalletPositionHistoryItem({ order, tab, t }) {
  const pair = resolvePositionPairLabel(order) || t('common.dash');
  const direction = resolvePositionDirectionLabel(t, tab, order);
  const amount = resolvePositionAmount(order, tab);
  const profitLoss = order?.profitLoss;
  const time = resolvePositionTime(order, tab);
  const status = resolvePositionStatusLabel(t, tab, order);
  const pnlTone = getAmountTone(profitLoss);

  return (
    <li className="funds-position-item">
      <div className="funds-position-item__main">
        <div className="funds-position-item__left">
          <div className="funds-position-item__title">
            {pair}
            {' · '}
            {direction}
          </div>
          <div className="funds-position-item__meta">
            {tf(t, 'funds.positionAmountLabel', { amount: formatFundAmount(amount) })}
          </div>
          <div className="funds-position-item__time">
            {time ? formatDateTime(time) : t('common.dash')}
          </div>
        </div>
        <div className="funds-position-item__right">
          <div className={`funds-position-item__pnl is-${pnlTone}`}>
            {profitLoss == null ? t('common.dash') : formatSignedFundAmount(profitLoss)}
          </div>
          <div className="funds-position-item__status">{status}</div>
        </div>
      </div>
    </li>
  );
}
